import { IPayout } from '@lbs/shared-rp-types'
import prp2boxHttp from '../../services/prp2boxHttp'

export interface IRpCombinationMultiplier extends IPayout {}

export interface IRpPayout {
  id: number
  name: string
  data: Array<IRpCombinationMultiplier>
  createdAt: string
  updatedAt: string
}

export interface CreateRpPayoutPayload extends Pick<IRpPayout, 'name'> {}

class RpPayoutApi {
  prefix: string = '/payouts'

  getAll = async (params: {
    limit?: number
    offset?: number
  }): Promise<{
    rows: IRpPayout[]
    totalRows: number
  }> => {
    const response = await prp2boxHttp.get(this.prefix, { params })
    return response.data
  }

  getById = async (id: number): Promise<IRpPayout> => {
    const response = await prp2boxHttp.get(`${this.prefix}/${id}`)
    return response.data
  }

  create = async (payload: CreateRpPayoutPayload): Promise<void> => {
    const response = await prp2boxHttp.post(this.prefix, payload)
    return response.data
  }

  update = async (id: number, payload: CreateRpPayoutPayload): Promise<void> => {
    const response = await prp2boxHttp.put(`${this.prefix}/${id}`, payload)
    return response.data
  }
}

export default new RpPayoutApi()
